import { ToggleButton } from "@/components/ToggleButton";
import React from "react";

export type SubscriptionSelectorValue = "subscription" | "one-time";

export type SubscriptionSelectorProps = {
  value: SubscriptionSelectorValue | undefined;
  onChange: (value: SubscriptionSelectorValue) => void;
  size?: "sm" | "md" | "lg";
  cta?: React.ReactNode;
};

export const SubscriptionSelector = ({
  value,
  onChange,
  size = "md",
  cta,
}: SubscriptionSelectorProps) => {
  return (
    <form className="space-y-4">
      <div
        className="flex space-x-4"
        aria-label="Select to subscribe or purchase one-time"
        role="radiogroup"
      >
        <div className="flex-1">
          <ToggleButton
            className="w-full"
            name="subscription-select"
            size={size}
            label={"Subscription"}
            selected={value === "subscription"}
            onClick={() => {
              onChange("subscription");
            }}
          />
        </div>
        <div className="flex-1">
          <ToggleButton
            className="w-full"
            name="subscription-select"
            size={size}
            label={"One-time Purchase"}
            selected={value === "one-time"}
            onClick={() => {
              onChange("one-time");
            }}
          />
        </div>
      </div>
      {value == "subscription" && (
        <div className="flex items-center justify-between space-x-4">{cta}</div>
      )}
    </form>
  );
};
